import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import LoadingOverlay from '../../components/_molecules/LoadingOverlay/LoadingOverlay';
import {
  publicHash,
  AUTH_STATES,
  LOADING,
  INIT,
  PROFILE_STEP_STATUSES,
} from '../../utils/constants';

const PRIVATE_ROOT = `${publicHash}/app`;
const PUBLIC_ROOT = `${publicHash}/auth`;

class ProtectedRoute extends Component {
  static propTypes = {
    component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
      .isRequired,
    checkAuthorized: PropTypes.func.isRequired,
    isAuthorized: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    profile: PropTypes.shape({}).isRequired,
    getProfileStatus: PropTypes.func.isRequired,
    registrationStoreStatus: PropTypes.string.isRequired,
    userStoreStatus: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    profileStepStatus: PropTypes.string.isRequired,
    getProfile: PropTypes.func.isRequired,
    linkedinStatus: PropTypes.string.isRequired,
    history: PropTypes.shape({
      location: PropTypes.shape({}.isRequired),
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  state = {
    hasAccessToApp: false,
  };

  componentDidMount() {
    this.props.checkAuthorized();
  }

  componentDidUpdate(prevProps) {
    const {
      id: prevId,
      isAuthorized: prevIsAuthorized,
      profileStepStatus: prevProfileStepStatus,
    } = prevProps;
    const {
      id,
      isAuthorized,
      profileStepStatus,
      getProfile,
      getProfileStatus,
      history,
    } = this.props;
    if (isAuthorized !== prevIsAuthorized) {
      if (isAuthorized === AUTH_STATES.AUTH) {
        getProfile();
      }
      if (isAuthorized === AUTH_STATES.DEAUTH) {
        this.removePreloader();
        this.setState(() => ({ hasAccessToApp: false }), () => {});
      }
    }
    if (isAuthorized === AUTH_STATES.AUTH && prevId !== id && id !== -1) {
      getProfileStatus();
    }
    if (
      isAuthorized === AUTH_STATES.AUTH &&
      profileStepStatus !== prevProfileStepStatus
    ) {
      if (
        profileStepStatus !== INIT &&
        profileStepStatus !== PROFILE_STEP_STATUSES.NO_PROFILE
      ) {
        this.setState(
          () => ({
            hasAccessToApp: true,
          }),
          () => {
            if (profileStepStatus === PROFILE_STEP_STATUSES.NO_APP) {
              history.push(`${publicHash}/app/create-first-app`);
            }
            if (profileStepStatus === PROFILE_STEP_STATUSES.NO_CAMPAIGN) {
              history.push(`${publicHash}/app/create-first-campaign`);
            }
            if (profileStepStatus === PROFILE_STEP_STATUSES.NO_PAYMENT_SOURCE) {
              history.push(`${publicHash}/app/add-payment`);
            }
            if (
              profileStepStatus === PROFILE_STEP_STATUSES.OK &&
              prevProps.profileStepStatus ===
                PROFILE_STEP_STATUSES.NO_PAYMENT_SOURCE
            ) {
              history.push(`${publicHash}/app/refill`);
            }
            this.removePreloader();
          },
        );
      }
      if (profileStepStatus === PROFILE_STEP_STATUSES.NO_PROFILE) {
        history.push(`${publicHash}/auth/registration-info`);
        this.removePreloader();
      }
    }
  }

  removePreloader = () => {
    const ele = document.getElementById('start-preloader-wrapper');
    if (ele) {
      ele.outerHTML = '';
    }
  };
  renderProtectedRoute = () => {
    const { component, isAuthorized, ...props } = this.props;
    const { isPrivate } = component;
    const { hasAccessToApp } = this.state;
    if (hasAccessToApp) {
      // User is Authenticated

      if (isPrivate) {
        return <Route {...props} component={component} />;
      }
      return <Redirect to={PRIVATE_ROOT} />;
    }
    // User is not Authenticated
    return isPrivate ? (
      <Redirect to={PUBLIC_ROOT} />
    ) : (
      <Route {...props} component={component} />
    );
  };

  render() {
    const {
      userStoreStatus,
      registrationStoreStatus,
      status,
      linkedinStatus,
    } = this.props;
    const isLoading =
      userStoreStatus === LOADING ||
      registrationStoreStatus === LOADING ||
      status === LOADING ||
      linkedinStatus === LOADING;
    return (
      <React.Fragment>
        <LoadingOverlay visible={isLoading} /> {this.renderProtectedRoute()}
      </React.Fragment>
    );
  }
}

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/containers/ProtectedRoute/ProtectedRoute.js